import React from "react";
import {
    List,
    Datagrid,
    TextField,
    BooleanField,
    NumberField,
    DateField,
    Show,
    SimpleShowLayout,
    FunctionField,
} from "react-admin";

const JsonBlock = ({ value }) => (
    <pre
        style={{
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            background: "#f6f6f6",
            padding: "12px",
            borderRadius: "8px",
            fontSize: "13px",
            lineHeight: 1.4,
        }}
    >
        {JSON.stringify(value ?? {}, null, 2)}
    </pre>
);

export const PreliminaryRunList = () => (
    <List
        perPage={25}
        sort={{ field: "created_at", order: "DESC" }}
        title="Предварительный анализ"
    >
        <Datagrid rowClick="show" bulkActionButtons={false}>
            <DateField source="created_at" label="Дата" showTime />
            <TextField source="username_snapshot" label="Пользователь" />
            <BooleanField source="success" label="Успешно" />
            <NumberField source="request_pdf_count" label="PDF" />
            <BooleanField source="has_excel" label="Excel" />
            <BooleanField source="excel_valid" label="Excel OK" />
            <NumberField source="summary_banks" label="Банков" />
            <NumberField source="summary_files" label="Файлов" />
            <NumberField source="summary_ready" label="Готово" />
            <NumberField source="summary_restricted" label="Нет подписки" />
            <NumberField source="summary_modified" label="Модиф." />
            <NumberField source="summary_unknown" label="Неизв." />
            <NumberField source="duration_ms" label="Время, мс" />
        </Datagrid>
    </List>
);

export const PreliminaryRunShow = () => (
    <Show title="Запуск предварительного анализа">
        <SimpleShowLayout>
            <DateField source="created_at" label="Дата" showTime />
            <TextField source="username_snapshot" label="Пользователь" />
            <BooleanField source="success" label="Успешно" />
            <NumberField source="duration_ms" label="Время, мс" />
            <TextField source="error_message_short" label="Ошибка" />

            <NumberField source="request_pdf_count" label="Количество PDF" />
            <BooleanField source="has_excel" label="Есть Excel" />
            <BooleanField source="excel_valid" label="Excel валиден" />
            <TextField source="excel_error_message" label="Ошибка Excel" />

            <NumberField source="summary_banks" label="Банков" />
            <NumberField source="summary_files" label="Файлов" />
            <NumberField source="summary_original" label="Оригинальные" />
            <NumberField source="summary_ready" label="Готовы" />
            <NumberField source="summary_restricted" label="Нет подписки" />
            <NumberField source="summary_modified" label="Модифицированные" />
            <NumberField source="summary_unknown" label="Неизвестные" />

            <NumberField source="unique_bin_count" label="Уникальных БИН" />
            <NumberField source="unique_gov_code_count" label="Уникальных кодов ГУ" />

            <FunctionField
                label="summary_json"
                render={(record) => <JsonBlock value={record?.summary_json} />}
            />
            <FunctionField
                label="ready_for_compare_json"
                render={(record) => <JsonBlock value={record?.ready_for_compare_json} />}
            />
            <FunctionField
                label="identifiers_json"
                render={(record) => <JsonBlock value={record?.identifiers_json} />}
            />
        </SimpleShowLayout>
    </Show>
);